import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function WorkOrderCard({ workOrder }) {
  const printRef = useRef();

  const auth = useSelector((state) => state.authentication);
  const { branchData } = auth;

  const [formData, setFormData] = useState({
    itemName: workOrder?.itemName || workOrder?.productName || "",
    workOrderId: workOrder?.workOrderId || workOrder?.batchNumber || "",
    department: workOrder?.department || workOrder?.processLine || "",
    fiscalYear: workOrder?.fiscalYear || workOrder?.targetYear || "",
    date: "",
    place: "",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>Work Order - ERP</title>
          <style>
            body {
              font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
              padding: 40px;
            }

            .header {
              text-align: center;
              margin-bottom: 20px;
            }

            .logo {
              width: 100px;
              margin-bottom: 10px;
            }

            .title {
              font-weight: bold;
              font-size: 22px;
              text-transform: uppercase;
              letter-spacing: 1px;
            }

            .subtitle {
              font-weight: 600;
              font-size: 16px;
              margin-bottom: 25px;
              color: #444;
            }

            .field-row {
              margin: 18px 0;
              font-size: 15px;
            }

            .label {
              display: inline-block;
              width: 220px;
              font-weight: bold;
              color: #222;
            }

            .line {
              display: inline-block;
              border-bottom: 1px solid #333;
              width: 60%;
              height: 18px;
              padding-left: 8px;
            }

            .footer {
              margin-top: 80px;
            }

            .left {
              float: left;
            }

            .right {
              float: right;
              font-weight: bold;
              text-align: center;
              border-top: 1px solid #000;
              padding-top: 5px;
              min-width: 180px;
            }

            .clear {
              clear: both;
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">
      {/* PRINT AREA */}
      <div ref={printRef}>
        <div className="header">
          {branchData?.logo && (
            <img
              src={branchData.logo}
              alt="Company Logo"
              className="logo"
            />
          )}

          <div className="title">
            {branchData?.companyName || "GLOBAL MANUFACTURING CORP"}
          </div>

          <div className="subtitle">PRODUCTION WORK ORDER</div>
        </div>

        <div className="field-row">
          <span className="label">ITEM / PRODUCT NAME</span> :
          <span className="line">{formData.itemName}</span>
        </div>

        <div className="field-row">
          <span className="label">WORK ORDER / BATCH NO.</span> :
          <span className="line">{formData.workOrderId}</span>
        </div>

        <div className="field-row">
          <span className="label">DEPARTMENT / LINE</span> :
          <span className="line">{formData.department}</span>
        </div>

        <div className="field-row">
          <span className="label">FISCAL / TARGET YEAR</span> :
          <span className="line">{formData.fiscalYear}</span>
        </div>

        <div className="footer">
          <div className="left">
            <div>Issue Date : {formData.date}</div>
            <div>Facility / Plant : {formData.place}</div>
          </div>

          <div className="right">AUTHORIZED SIGNATURE</div>

          <div className="clear"></div>
        </div>
      </div>

      {/* FORM INPUTS */}
      <Form className="mt-4">
        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Item / Product Name"
              value={formData.itemName}
              onChange={(e) => handleChange("itemName", e.target.value)}
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Work Order / Batch No."
              value={formData.workOrderId}
              onChange={(e) => handleChange("workOrderId", e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Department / Line"
              value={formData.department}
              onChange={(e) => handleChange("department", e.target.value)}
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Fiscal Year"
              value={formData.fiscalYear}
              onChange={(e) => handleChange("fiscalYear", e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              type="date"
              value={formData.date}
              onChange={(e) => handleChange("date", e.target.value)}
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Plant / Location"
              value={formData.place}
              onChange={(e) => handleChange("place", e.target.value)}
            />
          </Col>
        </Row>

        <Button onClick={handlePrint} className="mt-3" variant="primary">
          Print Work Order
        </Button>
      </Form>
    </Container>
  );
}